import { render, staticRenderFns } from "./category.vue?vue&type=template&id=c4188180&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=c4188180&prod&lang=css"
import style1 from "./category.vue?vue&type=style&index=1&id=c4188180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4188180",
  null
  
)

export default component.exports